/**
 * Component for the breadcrumbs for the standards mapping page
 */
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import Link from "@khanacademy/wonder-blocks-link";
import {HeadingXSmall} from "@khanacademy/wonder-blocks-typography";
import {doNotTranslate} from "@repo/i18n";

type Props = {
    countrySlug: string;
    regionIds: Array<string> | null | undefined;
};

function MappingBreadcrumbs({
    countrySlug,
    regionIds,
}: Props): React.ReactElement {
    const standardsHubPageLink = `/regions/${countrySlug}`;

    const unambiguousBreadcrumbRegionId =
        regionIds?.length === 1 ? regionIds[0] : undefined;

    // TODO(CP-7373): Use wonderblocks breadcrumbs
    return (
        <View style={styles.cardBreadcrumbs}>
            <Link href={standardsHubPageLink}>
                <HeadingXSmall>{doNotTranslate`STANDARDS`}</HeadingXSmall>
            </Link>
            {unambiguousBreadcrumbRegionId ? (
                <>
                    <HeadingXSmall>{" > "}</HeadingXSmall>
                    {/* TODO(CP-7372): Link to the region slug */}
                    {/* For now adding a label (not linked) with the ID */}
                    <HeadingXSmall>
                        {unambiguousBreadcrumbRegionId}
                    </HeadingXSmall>
                </>
            ) : null}
        </View>
    );
}

const styles = StyleSheet.create({
    cardBreadcrumbs: {
        flexDirection: "row",
    },
});

export default MappingBreadcrumbs;
